export class StatusSituacaoModel {
    constructor(
        public codigo: number = 1,
        public descricao: string = ''
    ) { }
}